module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/consigner.d065bc68.svg";